<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "School Vehicles",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "School Vehicles",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Transport",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "type",
          label: "Type",
          sortable: true,
        },
        {
          key: "plate",
          label: "Plate Number",
          sortable: true,
        },
        {
          key: "driver.name",
          label: "Driver",
          sortable: true,
        },
        {
          key: "user",
          label: "Added By",
          sortable: true,
        },
        {
          key: "addedon",
          label: "Added",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        plate: "",
        driver: "",
        type: "",
      },
      deletePos: {
        plate: "",
        id: "",
      },
      editPos: {
        type: "",
        plate: "",
        driver: "",
        id: "",
      },
      existingVehicle: [],
      typeError: "",
      plateError: "",
      driverError: "",
      modal: "",
    };
  },
  computed: {
    ...mapGetters("transport", ["Vehicles","Drivers", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.Vehicles.length;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Vehicles.length;
  },
  methods: {
    ...mapActions({
      FetchVehicles: "transport/fetchVehicles",
      FetchDrivers: "transport/fetchDrivers",
      AddVehicle: "transport/addVehicle",
      EditVehicle: "transport/editVehicle",
      DeleteVehicle: "transport/deleteVehicle",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.Vehicles.length;
      this.currentPage = 1;
    },

    resetError() {
      this.typeError = "";
      this.plateError = "";
      this.driverError = "";
    },

    resetAddModal() {
      this.data.plate = "";
      this.data.type = "";
      this.data.driver = "";
      this.resetError();
    },

    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingVehicle = this.Vehicles.filter((ditance) => {
          return ditance.plate.toUpperCase() == this.data.plate.toUpperCase();
        });
        if (this.existingVehicle.length) {
          this.typeError = this.data.plate + " exists already";
        } else {
          this.typeError = "";
        }
      } else {
        this.existingVehicle = [];
      }
    },
    addVehicle(modal) {
      if (this.data.type == "") {
        this.typeError = "Vehicle type field can't be empty";
        return;
      } else {
        this.typeError = "";
      }
      if (this.data.plate == "") {
        this.plateError = "Car plate number can't be empty";
        return;
      } else {
        this.plateError = "";
      }
      if (this.data.driver == "") {
        this.driverError = "Car driver number can't be empty";
        return;
      } else {
        this.driverError = "";
      }
      if (this.existingVehicle.length) {
        this.typeError = this.data.location + " exists already Please";
        return;
      } else {
        this.typeError = "";
      }
      this.modal = modal;
      this.AddVehicle(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    showEditModal(values) {
      this.editPos.id = values.item.id;
      this.editPos.plate = values.item.plate;
      this.editPos.type = values.item.type;
      this.editPos.driver = values.item.driver?values.item.driver.id:"";
    },
    showDeleteModal(values) {
      this.deletePos.id = values.item.id;
      this.deletePos.plate = values.item.plate;
    },
    deleteVehicle(modal) {
      this.modal = modal;
      this.DeleteVehicle(this.deletePos);
      this.closeModal(modal);
    },
    editVehicle(modal) {
      if (this.editPos.type == "") {
        this.typeError = "Vehicle type field can't be empty";
        return;
      } else {
        this.typeError = "";
      }
      if (this.editPos.plate == "") {
        this.plateError = "Car plate Number field can't be empty";
        return;
      } else {
        this.plateError = "";
      }
      if (this.editPos.driver == "") {
        this.driverError = "Car driver Number field can't be empty";
        return;
      } else {
        this.driverError = "";
      }
      this.modal = modal;
      this.EditVehicle(this.editPos);
      this.resetError();
      this.closeModal(this.modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchVehicles();
    this.FetchDrivers();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_staff_position')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">List of School Vehicles</h3>
              </div>
              <div class="col-3">
                <button
                  v-b-modal.add-modal
                  class="btn btn-primary float-end"
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_staff_position')
                    )
                  "
                >
                  <i class="fa fa-plus"></i> Add New
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Vehicles"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-modal
                      @click="showEditModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_staff_position')
                        )
                      "
                      ><i class="fa fa-edit"></i> Edit</b-button
                    >
                    <b-button
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-modal
                      @click="showDeleteModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('delete_staff_position')
                        )
                      "
                      ><i class="fa fa-trash"></i> Delete</b-button
                    >
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal
        id="add-modal"
        hide-footer
        @hidden="resetAddModal"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_staff_position')
          )
        "
      >
        <template #modal-title> Add New Vehicle </template>
        <div class="form-group mb-3">
          <label>Car Type</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Car Type e.g Bus, Truck, Van"
              class="form-control"
              @input="resetError"
              v-model="data.type"
            />
          </div>
          <div class="text-danger" v-if="typeError">
            <em>{{ typeError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Car Plate Number</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Car Plate Number"
              class="form-control"
              v-model="data.plate"
              @keyup="checkName"
            />
          </div>
          <div class="text-danger" v-if="plateError">
            <em>{{ plateError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Car Driver</label>
          <div class="input-group">
            <model-list-select
                required
                :list="Drivers ? Drivers : []"
                v-model="data.driver"
                option-value="id"
                option-text="name"
                class="mb-2"
                placeholder="Choose Driver"
              >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="driverError">
            <em>{{ driverError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('add-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="addVehicle('add-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal
        id="edit-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_staff_position')
          )
        "
      >
        <template #modal-title> Edit Vehicle {{ editPos.plate }}</template>
        <div class="form-group mb-3">
          <label>Car Type</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Car Type e.g Bus, Truck, Van"
              class="form-control"
              @input="resetError"
              v-model="editPos.type"
            />
          </div>
          <div class="text-danger" v-if="typeError">
            <em>{{ typeError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Car Plate Number</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Car Plate Number"
              class="form-control"
              v-model="editPos.plate"
              @keyup="checkName"
            />
          </div>
          <div class="text-danger" v-if="plateError">
            <em>{{ plateError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Car Driver</label>
          <div class="input-group">
            <model-list-select
                required
                :list="Drivers ? Drivers : []"
                v-model="editPos.driver"
                option-value="id"
                option-text="name"
                class="mb-2"
                placeholder="Choose Driver"
              >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="driverError">
            <em>{{ driverError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('edit-position-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="editVehicle('edit-position-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete position starts -->
      <b-modal
        id="delete-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_staff_position')
          )
        "
      >
        <template #modal-title>
          <h4 class="text-danger">
            Delete Vehicle {{ deletePos.plate }}
          </h4></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Do you want to delete Vehicle {{ deletePos.plate }}? Click Proceed
              Button to delete.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click="deleteVehicle('delete-modal')"
          >
            <i class="fa fa-trash"></i> Proceed</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
